import Cookies from "js-cookie";

function getDomain() {
  return `.${window.location.host
    .split(".")
    .slice(-2)
    .join(".")}`;
}
export function getToken(TokenKey) {
  return Cookies.get(TokenKey);
}

export function setToken(TokenKey, token) {
  Cookies.set(TokenKey, token);
  // document.cookie = `${TokenKey}=${token};Path=/;domain=${getDomain()}`;
}

export function removeToken(TokenKey) {
  return Cookies.remove(TokenKey);
}

/**
 * @description: 清除一级域名下的或指定的，例如 .ratingdog.cn
 * @param {*}
 * @return {*}
 */
export function clearDomainCookie() {
  const keys = document.cookie.match(/[^ =;]+(?==)/g);
  const domain = getDomain();
  if (keys) {
    for (let i = keys.length; i--;) {
      document.cookie =
        keys[i] +
        "=0;path=/;domain=" +
        domain +
        ";expires=" +
        new Date(0).toUTCString(); // 清除一级域名下的或指定的，例如 .ratingdog.cn
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js